module.exports = __webpack_public_path__ + "static/media/2.2769067d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Tutorial/screenshots/Managing/2.jpg
// module id = 1636
// module chunks = 0